import { AiPart, PickType } from "@intelligems/ig-types";

import { getToolStep } from "@src/features/ai/utils/thought-process-steps";

import { StepRow } from "./StepRow";
import { WithDebugMessages } from "./WithDebugMessages";

import {
  FlattenedPart,
  MessageFlags,
} from "@src/features/ai/components/WorkflowEditor/execution/types";

type ToolCallMessageProps = {
  item: FlattenedPart;
  part: PickType<AiPart, "dynamic-tool">;
  /**
   * How many consecutive identical calls this row stands in for — rendered as a
   * "×N" badge instead of N identical rows.
   */
  repeatCount?: number;
} & MessageFlags;

/**
 * Renders a tool call as a single timeline step in the experience-agent
 * "thought process": an icon, a short past-tense title of what the step did,
 * and an optional one-line description derived from the tool's own arguments
 * (see `getToolStep`). Grouping these under one collapsible container is a
 * later step; for now each renders inline.
 */
export const DynamicTasks = ({
  item,
  part,
  debug,
  repeatCount,
}: ToolCallMessageProps) => {
  if (!part) {
    return null;
  }

  const { Icon, title, description } = getToolStep(part.toolName, part.input);

  return (
    <WithDebugMessages item={item} part={part} debug={debug}>
      <StepRow
        Icon={Icon}
        title={title}
        description={description}
        repeatCount={repeatCount}
      />
    </WithDebugMessages>
  );
};
